import { MermaidDiagram } from './MermaidDiagram';
import { CodeBlock } from './CodeBlock';
import { DataTable } from './DataTable';
import { InsightsCard } from './InsightsCard';
import { ConfigPreview } from './ConfigPreview';
import { PlanArtifact } from './PlanArtifact';
import type { Artifact } from '@/types';

interface ArtifactRendererProps {
  artifact: Artifact;
}

export function ArtifactRenderer({ artifact }: ArtifactRendererProps) {
  switch (artifact.type) {
    case 'mermaid':
      return <MermaidDiagram artifact={artifact} />;

    case 'code':
      return <CodeBlock artifact={artifact} />;

    case 'table':
      return <DataTable artifact={artifact} />;

    case 'insights':
      return <InsightsCard artifact={artifact} />;

    case 'config':
      return <ConfigPreview artifact={artifact} />;

    case 'markdown':
      // Markdown is rendered inline in the message, so we just return the content
      // wrapped in a card if it has a title
      if (artifact.title) {
        return (
          <div className="rounded-lg border border-gray-700 bg-gray-800 p-4">
            <h3 className="mb-2 font-medium text-gray-100">{artifact.title}</h3>
            <div className="prose prose-sm prose-invert max-w-none text-gray-200">
              {artifact.content}
            </div>
          </div>
        );
      }
      return null;

    case 'plan':
      return <PlanArtifact artifact={artifact} />;

    default:
      // Unknown artifact type - render as code block
      return (
        <div className="rounded-lg border border-gray-700 bg-gray-800 p-4">
          <div className="mb-2 text-xs text-gray-400">
            Unknown artifact type: {artifact.type}
          </div>
          <pre className="text-sm overflow-x-auto text-gray-100">{artifact.content}</pre>
        </div>
      );
  }
}
